import React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';

import CRMSearchBar from './crm/crmSearchBar';
import HelpLinks from './helpLinks';

class ThirdRow extends React.Component {
    getCustomerServicePageSideHTML() {
        return this.props.customContent &&
            <div
                className="col-md-2"
                dangerouslySetInnerHTML={{ __html: this.props.customContent }}
            />;
    }

    render() {
        return <React.Fragment>
            <div className="col-md-10">
                <CRMSearchBar CSRRepTitle={this.props.CSRRepTitle} />
                <HelpLinks/>
            </div>
            {this.getCustomerServicePageSideHTML()}
            </React.Fragment>;
    }
}
function mapStateToProps(state) {
    return {
        customContent: state.customContent
    };
}
export default connect(mapStateToProps)(ThirdRow);
